/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DnspDerEventDevice } from "./DnspDerEventDevice";
import {
    DnspDerEventDeviceFromJSON,
    DnspDerEventDeviceFromJSONTyped,
    DnspDerEventDeviceToJSON,
} from "./DnspDerEventDevice";

/**
 *
 * @export
 * @interface DnspGetDerEventResponse
 */
export interface DnspGetDerEventResponse {
    /**
     *
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    derEventId?: string;
    /**
     * Short info about the event. May be sent in the opt-out sms. Up to 100 chars.
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    shortInfo?: string;
    /**
     * Longer description, not shown to users
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    description?: string;
    /**
     * All devices involved in this Der Event (including opted-out)
     * @type {Array<DnspDerEventDevice>}
     * @memberof DnspGetDerEventResponse
     */
    devices?: Array<DnspDerEventDevice>;
    /**
     * Event start time (used to schedule the opt out sms reminder). All Envelopes for this event must start after this time.
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    startUtc?: Date;
    /**
     * Event end time. All Envelopes for this event must end before this time.
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    endUtc?: Date;
    /**
     * Event type, eg Solar Soak or Demand Response. Event type is included in the SMS templates, and determines the icon shown on the ChargeMate display during the event.
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    derEventType?: DnspGetDerEventResponseDerEventTypeEnum;
    /**
     * Name of the organisation that created this event.
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    dnspName?: string;
    /**
     * Event status (scheduled / active / ended / cancelled)
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    status?: string;
    /**
     * Date the first opt-out message was sent to the device owner
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    optOutsSentAt?: Date;
    /**
     * Date any reminder message was sent to the device owner
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    remindersSentAt?: Date;
    /**
     * Date the event was cancelled by the DNSP
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    cancelledAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DnspGetDerEventResponse
     */
    updatedAt?: Date;
    /**
     * Count of all devices involved in this Der Event (including opted-out)
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    deviceCount?: number;
    /**
     * Count of all devices involved in this Der Event that opted-out
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    optOutCount?: number;
    /**
     * Count of all devices that did not opt out
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    participantCount?: number;
    /**
     * TODO NYI. The number of participants that had an EV plugged in at any time during the event
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    participantPluggedInCount?: number;
    /**
     * TODO NYI. The number of participants plugged in that actually charged their EV during the event
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    participantChargingCount?: number;
    /**
     * TODO NYI. The estimated total amount of power saved (load shed). See https://jetcharge.atlassian.net/browse/ILLUM-765 for a discussion of how this is calculated.
     * @type {number}
     * @memberof DnspGetDerEventResponse
     */
    powerSavedWh?: number;
    /**
     * The template used for the initial SMS
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    initialTemplate?: string;
    /**
     * The template used for the reminder SMS
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    reminderTemplate?: string;
    /**
     * The template used for the start SMS
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    startTemplate?: string;
    /**
     * The template used for the end SMS
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    endTemplate?: string;
    /**
     * The template used for the cancellation SMS
     * @type {string}
     * @memberof DnspGetDerEventResponse
     */
    cancelledTemplate?: string;
}

/**
 * @export
 */
export const DnspGetDerEventResponseDerEventTypeEnum = {
    Default: "Default",
    DemandResponse: "DemandResponse",
    SolarSoak: "SolarSoak",
} as const;
export type DnspGetDerEventResponseDerEventTypeEnum =
    (typeof DnspGetDerEventResponseDerEventTypeEnum)[keyof typeof DnspGetDerEventResponseDerEventTypeEnum];

/**
 * Check if a given object implements the DnspGetDerEventResponse interface.
 */
export function instanceOfDnspGetDerEventResponse(
    value: object,
): value is DnspGetDerEventResponse {
    return true;
}

export function DnspGetDerEventResponseFromJSON(
    json: any,
): DnspGetDerEventResponse {
    return DnspGetDerEventResponseFromJSONTyped(json, false);
}

export function DnspGetDerEventResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspGetDerEventResponse {
    if (json == null) {
        return json;
    }
    return {
        derEventId: json["derEventId"] == null ? undefined : json["derEventId"],
        shortInfo: json["shortInfo"] == null ? undefined : json["shortInfo"],
        description:
            json["description"] == null ? undefined : json["description"],
        devices:
            json["devices"] == null
                ? undefined
                : (json["devices"] as Array<any>).map(
                      DnspDerEventDeviceFromJSON,
                  ),
        startUtc:
            json["startUtc"] == null ? undefined : new Date(json["startUtc"]),
        endUtc: json["endUtc"] == null ? undefined : new Date(json["endUtc"]),
        derEventType:
            json["derEventType"] == null ? undefined : json["derEventType"],
        dnspName: json["dnspName"] == null ? undefined : json["dnspName"],
        status: json["status"] == null ? undefined : json["status"],
        optOutsSentAt:
            json["optOutsSentAt"] == null
                ? undefined
                : new Date(json["optOutsSentAt"]),
        remindersSentAt:
            json["remindersSentAt"] == null
                ? undefined
                : new Date(json["remindersSentAt"]),
        cancelledAt:
            json["cancelledAt"] == null
                ? undefined
                : new Date(json["cancelledAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        deviceCount:
            json["deviceCount"] == null ? undefined : json["deviceCount"],
        optOutCount:
            json["optOutCount"] == null ? undefined : json["optOutCount"],
        participantCount:
            json["participantCount"] == null
                ? undefined
                : json["participantCount"],
        participantPluggedInCount:
            json["participantPluggedInCount"] == null
                ? undefined
                : json["participantPluggedInCount"],
        participantChargingCount:
            json["participantChargingCount"] == null
                ? undefined
                : json["participantChargingCount"],
        powerSavedWh:
            json["powerSavedWh"] == null ? undefined : json["powerSavedWh"],
        initialTemplate:
            json["initialTemplate"] == null
                ? undefined
                : json["initialTemplate"],
        reminderTemplate:
            json["reminderTemplate"] == null
                ? undefined
                : json["reminderTemplate"],
        startTemplate:
            json["startTemplate"] == null ? undefined : json["startTemplate"],
        endTemplate:
            json["endTemplate"] == null ? undefined : json["endTemplate"],
        cancelledTemplate:
            json["cancelledTemplate"] == null
                ? undefined
                : json["cancelledTemplate"],
    };
}

export function DnspGetDerEventResponseToJSON(
    value?: DnspGetDerEventResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        derEventId: value["derEventId"],
        shortInfo: value["shortInfo"],
        description: value["description"],
        devices:
            value["devices"] == null
                ? undefined
                : (value["devices"] as Array<any>).map(
                      DnspDerEventDeviceToJSON,
                  ),
        startUtc:
            value["startUtc"] == null
                ? undefined
                : value["startUtc"].toISOString(),
        endUtc:
            value["endUtc"] == null ? undefined : value["endUtc"].toISOString(),
        derEventType: value["derEventType"],
        dnspName: value["dnspName"],
        status: value["status"],
        optOutsSentAt:
            value["optOutsSentAt"] == null
                ? undefined
                : value["optOutsSentAt"].toISOString(),
        remindersSentAt:
            value["remindersSentAt"] == null
                ? undefined
                : value["remindersSentAt"].toISOString(),
        cancelledAt:
            value["cancelledAt"] == null
                ? undefined
                : value["cancelledAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        deviceCount: value["deviceCount"],
        optOutCount: value["optOutCount"],
        participantCount: value["participantCount"],
        participantPluggedInCount: value["participantPluggedInCount"],
        participantChargingCount: value["participantChargingCount"],
        powerSavedWh: value["powerSavedWh"],
        initialTemplate: value["initialTemplate"],
        reminderTemplate: value["reminderTemplate"],
        startTemplate: value["startTemplate"],
        endTemplate: value["endTemplate"],
        cancelledTemplate: value["cancelledTemplate"],
    };
}
